import { Link } from "gatsby";
import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Col, Container, Row } from "react-bootstrap";
import Img1 from "../../../images/locationgcc/sa/pureplank.webp";
import Img2 from "../../../images/locationgcc/sa/mocuts.webp";
import Img3 from "../../../images/locationgcc/sa/reckn.webp";

const CaseStudy = [
  {
    title: "Pure Plank",
    description:
      "مركزك الأمثل على الإنترنت للصحة وتمارين اللياقة البدنية في المنزل.",
    link: "pure-plank",
    Img: Img1,
    BgColor: "#121212",
    TextColor: "#FFFFFF",
  },
  {
    title: "Mocuts",
    description: "وجهتك النهائية لحجز الحلاقين المحترفين بسلاسة.",
    link: "mocuts",
    Img: Img2,
    BgColor: "#DC3C2A",
    TextColor: "#FFFFFF",
  },
  {
    title: "Reckn",
    description: "تطبيق Reck’N الجوال الذي يعيد تعريف تجارب المطاعم.",
    link: "reck-n-case",
    Img: Img3,
    BgColor: "#4041AB",
    TextColor: "#FFFFFF",
  },
];

function StoriesCase(props) {
  return (
    <div className="case_section case_dubai">
      <Container className="h-100">
        <Row className="h-100">
          {CaseStudy.map((item, index) => (
            <Col
              xs={12}
              md={12}
              lg={10}
              xl={4}
              xxl={4}
              className="my-xl-auto m-lg-auto "
            >
              <div
                className="bg_case"
                style={{ backgroundColor: item.BgColor }}
              >
                <div className="case-content">
                  <h4 style={{ color: item.TextColor }}>{item.title}</h4>
                  <p style={{ color: item.TextColor }}>{item.description}</p>
                  <Link
                    to={
                      item.link
                        ? `/case-studies/${item.link}`
                        : "https://www.tekrevol.com/projects"
                    }
                    className="btn_case"
                  >
                    عرض الدراسة الكاملة
                  </Link>
                </div>
                <div className="case-img">
                  <LazyLoadImage
                    src={item.Img}
                    effect="blur"
                    alt="Image"
                    className="img-fluid"
                  />
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}

export default StoriesCase;
